import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { getRequests } from '../../../services/requests.service';
import MyRequestsUi from '../../../components/user-interfaces/my-requests/my-requests.ui';
import { RequestDto } from '../../../services/dtos/request.dto';

/**
 * Page mes factures, comportant toutes les factures de tous les contrats
 * @constructor
 */
export default function MyRequestsPage() {
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    const [requests, setRequests] = useState<Array<RequestDto>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    /**
     * Récupération des contrats associés à l'utilisateur connecté
     */
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;
        setLoading(true);
        getRequests('0')
            .then(data => {
                setRequests(data);
            })
            .catch(error => {
                //Affichage du message d'erreur si la request ne récupère rien
                console.error('Erreur lors de la récupération des demandes');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
            });
        // https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Création de la page avec pour chaque contrat leur tableau de factures.
     */
    return (
        <Fragment>
            <MyRequestsUi requests={requests} loading={loading} />
        </Fragment>
    );
}
